import { useDroppable } from '@dnd-kit/core';
import clsx from 'clsx';
import type { ReactNode } from 'react';
import { displayStatus, type StatusDemanda } from '@/lib/types';

interface Props {
  status: StatusDemanda;
  count: number;
  color: 'blue' | 'orange' | 'purple' | 'green' | 'pink';
  children: ReactNode;
}

const colorMap = {
  blue: 'border-blue/40',
  orange: 'border-orange/40',
  purple: 'border-purple/40',
  green: 'border-green/40',
  pink: 'border-pink/40',
} as const;

export function KanbanColumn({ status, count, color, children }: Props) {
  const { setNodeRef, isOver } = useDroppable({ id: status });

  return (
    <div className="flex flex-col min-w-0 bg-panel border border-border rounded-xl overflow-hidden">
      <div
        className={clsx(
          'flex items-center justify-between px-3 py-3 border-b border-border border-2 bg-panel-2',
          colorMap[color],
        )}
      >
        <h3 className="text-[11px] font-bold uppercase tracking-wider text-text-2 truncate">{displayStatus(status)}</h3>
        <span className="text-xs font-semibold text-muted bg-panel px-2 py-0.5 rounded-full">
          {count}
        </span>
      </div>
      <div
        ref={setNodeRef}
        className={clsx(
          'flex-1 overflow-y-auto p-3 space-y-2 transition-colors min-h-[200px]',
          isOver && 'bg-blue/5',
        )}
      >
        {children}
        {count === 0 && (
          <div className="text-xs text-muted text-center py-8 italic">
            arraste cards aqui
          </div>
        )}
      </div>
    </div>
  );
}
